import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Logo from 'components/common/logo';
import Bag from 'style/imgs/Backpack2.svg';

import styles from './index.module.scss';

interface ILocationState {
  role: string;
}

function getRoleTitle(role: string) {
  return role === 'Parent' ? role : 'Educator';
}

const Welcome: React.FC = () => {
  const location = useLocation<ILocationState>();
  const history = useHistory();

  useEffect(() => {
    if (!location.state?.role) {
      history.push('/choose-role');
    }
    localStorage.setItem('role', location.state.role);
    setTimeout(() => {
      history.push('/sign-up');
    }, 3000);
  }, [history, location.state.role]);

  return (
    <div className={styles.welcome}>
      <div className={styles.welcomeLeft}>
        <div className={styles.robot}>
          <img src={Bag} alt="img" />
        </div>
      </div>
      <div className={styles.welcomeRight}>
        <div>
          <div className={styles.logo}>
            <Logo />
          </div>
          <h1 className="deep-gray-heading bold">
            {`Welcome ${
              location.state?.role && getRoleTitle(location.state.role)
            }! Let’s get started!`}
          </h1>
          <p className="gray-text">
            Digital organization and wayfinding for scholars of any age.
          </p>
          <h2 className="orange-heading bold">
            {location.state?.role === 'Parent'
              ? `Give independence, Take back your day.`
              : `Empower families with organization.
             Make digital learning work`}
          </h2>
        </div>
        <a
          href="https://anetaed.zendesk.com/hc/en-us"
          target="_blank"
          rel="noreferrer"
          className="question"
        >
          ?
        </a>
      </div>
    </div>
  );
};

export default Welcome;
